import { DialogContent } from 'components/dialog';
import styled from 'styled-components';

export const InfographicDialogContent = styled(DialogContent)`
  width: unset;
  max-width: unset;

  ul {
    padding: 0;

    li + li {
      margin-top: 0;
    }
  }
`;
